import { Kit } from '@repo/types';

export default function checkIfKitIsUpdating(kit?: Kit) {
  if (!kit) return false;
  const resultsViewable =
    !!kit.date_survey_completed && !!kit.date_results_ready;

  // A NULL sci_version is the legacy upgrade signal, kept until the kits
  // upgraded that way are swept.
  const upgradeInProgress =
    kit.sci_version === null || !!kit.version_upgrade_in_progress;

  return upgradeInProgress && resultsViewable;
}
